import React from 'react';
import PropTypes from 'prop-types';

/**
 * QuickActions - Grid of action cards for navigation
 *
 * @param {Object} props
 * @param {boolean} props.isAdmin - Whether user has admin access
 * @param {boolean} props.isOffice - Whether user has office access
 * @param {boolean} props.isDM - Whether user has district manager access
 * @param {boolean} props.isAS - Whether user has area supervisor access
 * @param {Function} props.onNavigate - Navigation handler
 */
const QuickActions = ({ isAdmin, isOffice, isDM, onNavigate }) => {
  return (
    <div className="quick-actions-section">
      <h2>Quick Actions</h2>
      <div className="quick-actions-grid">
        {isAdmin && (
          <div className="action-card">
            <div className="action-icon">👤</div>
            <h3>Manage Users</h3>
            <p>View and manage portal users</p>
            <button className="btn-action" onClick={() => onNavigate('users')}>
              Go to Users
            </button>
          </div>
        )}

        {(isAdmin || isOffice || isDM) && (
          <div className="action-card">
            <div className="action-icon">🏢</div>
            <h3>Manage Stores</h3>
            <p>View and manage store locations</p>
            <button className="btn-action" onClick={() => onNavigate('stores')}>
              Go to Stores
            </button>
          </div>
        )}

        {(isAdmin || isOffice) && (
          <div className="action-card">
            <div className="action-icon">🗺️</div>
            <h3>Manage Districts</h3>
            <p>Configure districts and nested sub-area assignments</p>
            <button
              className="btn-action"
              onClick={() => onNavigate('districts')}
            >
              Go to Districts
            </button>
          </div>
        )}

        <div className="action-card">
          <div className="action-icon">📋</div>
          <h3>View Forms</h3>
          <p>Browse form submissions</p>
          <button className="btn-action" onClick={() => onNavigate('forms')}>
            Go to Forms
          </button>
        </div>

        {isAdmin && (
          <div className="action-card">
            <div className="action-icon">🔐</div>
            <h3>Security</h3>
            <p>Monitor active sessions</p>
            <button
              className="btn-action"
              onClick={() => onNavigate('sessions')}
            >
              Go to Sessions
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

QuickActions.propTypes = {
  isAdmin: PropTypes.bool.isRequired,
  isOffice: PropTypes.bool,
  isDM: PropTypes.bool,
  isAS: PropTypes.bool,
  onNavigate: PropTypes.func.isRequired,
};

QuickActions.defaultProps = {
  isOffice: false,
  isDM: false,
  isAS: false,
};

export default QuickActions;
